export default angular.module('nv.directives', ['nv.directives.tool-group']).name;
